export default class ContactFormBanner extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-contact-form-banner', ContactFormBanner);
